module.exports = __webpack_public_path__ + "img/arrow.0325b867.png";